import Typography from "components/typography";
import { StoreIconName, storeIcons } from "constants/storeIcons";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { IconNameConvert } from "../iconNameConvert";

interface IProps {
  country: string;
  totalStreamCount?: string;
  streams?: { name: string; streamCount: string }[];
}
const CountryStreamsDetails = ({ country, totalStreamCount }: IProps) => {
  const streamsData = [
    { name: "Spotify", streamCount: "3293" },
    { name: "Apple Music", streamCount: "1293" },
    { name: "Deezer", streamCount: "2293" },
    { name: "Amazon", streamCount: "3203" },
    { name: "Audiomack", streamCount: "1250" }
  ];
  return (
    <Container>
      <Typography size="12px" weight="medium" color={Colors.grey400} mb="0.5">
        {country}
      </Typography>
      <Typography size="12px" color={Colors.grey500} mb="1">
        Total Streams: {totalStreamCount}
      </Typography>

      <StoreStreamContainer>
        {streamsData.map(({ name, streamCount }, i) => {
          let iconName = IconNameConvert(name);

          return (
            <StoreItem key={i}>
              <StoreIcon>{storeIcons[iconName as StoreIconName]}</StoreIcon>
              <Typography color={Colors.grey500}>
                {Number(streamCount).toLocaleString()}
              </Typography>
            </StoreItem>
          );
        })}
      </StoreStreamContainer>
    </Container>
  );
};

export default CountryStreamsDetails;

const Container = styled.div`
  padding: 1rem;
  border-radius: 4.886px;
  background: #373737;
  width: 20rem;
`;
const StoreStreamContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
const StoreItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: fit-content;
`;

const StoreIcon = styled.div`
  width: 1.5rem;
  height: 1.5rem;
`;
